import React from "react";
import { Redirect } from "react-router-dom";
import { CCol, CRow, CCard, CCardBody, CCardHeader } from "@coreui/react";

//** Libs */
import BaseComponent from "../../../shared/baseComponent";
import Button from "../../../components/ui-components/Button";
import { QueryParams } from "../../../navigation/NavigationLib";
import FormFieldGroup from "../../../components/FormGrop/FormFieldGroup";
import LoadingImg from "../../../components/common/loadingImg/LoadingImage";

//** Service */
import UserDomainServices from "../../../services/domainServices/userDomainServices";


export default class UserDetail extends BaseComponent {
    constructor(props) {
        super(props);
        this.userServices = new UserDomainServices();
        this.state = {
            ...this.state,
            userDetail: this.userServices.dataItem,
            isLoading: false,
            redirect: null,
            resetValidationRule: {},
        }
        this.userServices.onUpdateState = this.updateState.bind(this);
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.userServices.onInitService();
        document.title = "IMS - Add User";
        const urlParams = QueryParams(this.props.location.pathname);
        if (urlParams.length > 0 && urlParams[0] !== "") {
            this.setState({ pkId: parseInt(urlParams[0]) });
            document.title = "IMS - Edit User";
            this.userServices.onGetUserById(parseInt(urlParams[0]));
        }
    }

    /// Handle the user input changes
    handleChange(key, value) {
        let user = this.state.userDetail;
        user[key] = value;
        this.setState({ userDetail: { ...user } });
    }

    //Add/edit user
    addEditUser() {
        if (this.state.pkId > 0) {
            if (this.userServices.isValidSubmit(this.state.userDetail, this.state.validationRules, this.state.validState)) {
                this.editUser();
            }
        } else {
            if (this.userServices.isValidSubmit(this.state.userDetail, this.state.validationRules, this.state.validState)) {
                this.userServices.onAddUser(this.state.userDetail);
            }
        }
    }

    editUser() {
        let UserEdit = { ...this.state.userDetail };
        UserEdit.userId = this.state.pkId;
        this.userServices.onUpdateUser(UserEdit);
    }

    handleChange(name, value) {
        let detail = this.state.userDetail;
        detail[name] = value;
        this.setState({ userDetail: { ...detail } });
    }
    render() {
        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />
        }
        return (
            <>
                <CRow>
                    <CCol>
                        <CCard className="shadow">
                            <CCardHeader>
                                <h5> User  </h5>
                            </CCardHeader>
                            {(this.state.isLoading) ?
                                <CCardBody className="min_h_300">
                                    <LoadingImg id="loader_img" />
                                </CCardBody>
                                :
                                <CCardBody>
                                    <CRow>
                                        {this.userServices.formFields.map((Item, index) => {
                                            return (
                                                < >
                                                    <FormFieldGroup
                                                        column={Item}
                                                        value={this.state.userDetail[Item.fieldName]}
                                                        error={this.state.validState.error[Item.fieldName]}
                                                        onChange={(event) => Item.checked != true ? this.handleChange(Item.fieldName, event.target.value)
                                                            : this.handleChange(Item.fieldName, event.target.checked)}
                                                        checked={Item.checked === true ? this.state.userDetail[Item.fieldName] : null}
                                                        onBlur={() => this.userServices.validateField(Item.fieldName, this.state.userDetail, this.state.validationRules, this.state.validState)}
                                                        key={index} />
                                                </>
                                            )
                                        })}
                                    </CRow>
                                    <CRow>
                                        <CCol md="12" >
                                            <Button type={"dark"} text={"Submit"} onClick={() => this.addEditUser()} loading={this.state.btnLoading} />
                                            <Button type={"secondary"} text={"Cancel"} onClick={() => this.userServices.backToUserList()} />
                                        </CCol>
                                    </CRow>
                                </CCardBody>
                            }
                        </CCard>
                    </CCol>
                </CRow>
            </>
        )
    }
}
